import React from "react";
import { MapContainer } from "./MapContainer";
import { NouvelleFenetre } from "../../../../components/common/NouvelleFenetre";

export const SectionContainer = ({title, openMedia, selectedItem, addressInfos, outlineCity, scenario, updateAddress, onSelectScenario}) => {

    return (
        <div className={`info-container ${(selectedItem.maps || selectedItem.alternativeMap) ? 'info-container--map' : ''}`}>
            <div className="text-container">
                {title && <h2>{title}</h2>}
                { selectedItem.infos && selectedItem.infos.map( info =>
                    <>
                        <h3>{info.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: info.content}}/>
                    </>
                )}
            </div>
            {selectedItem && selectedItem.maps &&
                <MapContainer
                    selectedItem={selectedItem}
                    addressInfos={addressInfos}
                    outlineCity={outlineCity}
                    scenario={scenario}
                    updateAddress={updateAddress}
                    onSelectScenario={onSelectScenario}
                />
            }
            {selectedItem.alternativeMap &&
                <div className="map-container map-section alternative-map">
                    {selectedItem.alternativeMap.type === 'img' &&
                        <>
                            <div className="picture-map">
                                <div class="picture">
                                    <img src={selectedItem.alternativeMap.src} alt={''} />
                                </div>
                                <p>{selectedItem.alternativeMap.title}</p>
                            </div>
                        </>
                    }
                    {selectedItem.alternativeMap.type === "table" &&
                        <table>
                            <caption><strong>{selectedItem.alternativeMap.title}</strong></caption>
                            <thead>
                                <tr>
                                    {selectedItem.alternativeMap.tableHeaders.map(header => <th>{header}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {selectedItem.alternativeMap.entries.map(entry =>
                                    <tr>
                                        {entry.map(i => <td>{i}</td>)}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    }
                </div>
            }
            {selectedItem.medias && selectedItem.medias.length > 0 &&
                <div className="medias-container">
                    <h3>Médias</h3>
                    <ul className="media-list">
                        {selectedItem.medias.map((media, index) =>
                            <li className="media-item" key={`media-${index}`}>
                                <div className="picture">
                                    {media.type === 'site' || media.type === 'pdf'
                                        ?
                                        <a href={media.src} target="_blank" rel="noreferrer noopener" title={`${media.title}${media.type === 'pdf' ? ' (PDF)' : ''} (nouvelle fenêtre)`}>
                                            <img src={media.thumbnail} alt=""/>
                                            <span className="sr-only">{media.title}{media.type === 'pdf' ? ' (PDF)' : ''}</span>
                                            <NouvelleFenetre/>
                                        </a>
                                        :
                                        <img
                                            src={media.thumbnail ? media.thumbnail : media.src}
                                            alt=""
                                            onClick={() => openMedia(media)}
                                        />
                                    }
                                </div>
                                <p>{media.title}</p>
                            </li>
                        )}
                    </ul>
                </div>
            }
        </div>
    )
}